<ng-container *transloco="let t;">
    <div class="container-fluid p-0">
        <div class="row p-0">
        <div class="col-12 col-lg-5 col-md-12 p-2 bulkUpload-rightColumn-border border-end">
            <div class="background-wrapper file-drop-zone" (fileDropped)="onFileDropped($event)" appDropFiles>
                <input class="fileDrop" type="file" multiple (change)="onFileDropped($event)"
                       [accept]="acceptableFiles"/>
                <div class="upload-icon-img ">
                    <img src="../../../../assets/images/icons/uploadIcon-files.png" alt="upload files">
                </div>
                <span class="font-weight-500">{{ t('Upload PDF files or drag and drop text (upload file modal) - Upload files or drag and drop') }}</span>
                <span class="csv-file-supported-text">{{ t('Supported files explanation (upload file modal) - Only PDF (.pdf) file type is supported') }}
                    </span>
            </div>
        </div>


        <div class="col-12 col-lg-7 col-md-12 pt-2 pb-2 ps-2 pe-0 dropped-files-list">
              <div class="uploaded-files-area">
                    <form [formGroup]="form">
                        <div formArrayName="files">
                            @for (file of formFiles?.controls; track file.value; let i = $index) {
                                <app-basic-file-upload
                                    [ngClass]="{'invalid': file.invalid, 'file-size': file?.get('file')?.hasError('maxSize')}"
                                    [formGroupName]="i"
                                    class="mb-1"
                                    [file]="file.value.file"
                                    [progress]="file.value?.progress || 0 "
                                    [ngbTooltip]=" file | fileValidationTooltipText"
                                    (delete)="onFileDelete(i)"
                                >

                                 
                                    <div class="col-md-4 col-sm-12 form-group mb-0 p-0 category-and-doc-type">
                                        <ng-select
                                              #SelectSizeDefault
                                              [items]="(documentTypes$ | async) | documentTypeSelectorFor: section"
                                              [searchable]="false"
                                              formControlName="document_type_id"
                                              bindLabel="document_type"
                                              bindValue="id"
                                              class="ng-select-modal-dropdown-panel bulk-upload-select"
                                              [placeholder]="t('Document type label (general) - Document type')"
                                              (change)="onDocumentTypeChange($event, file)"
                                              
                                            >
                                              <ng-template ng-header-tmp>
                                                <input
                                                  class="form-control w-100"
                                                  type="text"
                                                  (input)="SelectSizeDefault.filter($event.target.value)"
                                                />
                                              </ng-template>

                                              <ng-template ng-option-tmp let-item="item" let-index="index">
                                                <span [ngClass]="{'potential-match': (file?.value.file | docTypeFromPdf: pdfMatching | idIncluded: item.id) }">
                                                    {{ item.document_type }}
                                                </span>
                                            </ng-template>
                                        </ng-select>
                        
                                        <div *ngIf="file && file.get('document_type_id').errors"
                                             class="invalid-feedback d-block">
                                            <div *ngIf="file.get('document_type_id').errors.required">
                                                {{t('Field required (form validation) - Field name is required',{
                                                fieldName: t('Document type label (general) - Document type')}) }}
                                            </div>
                                        </div>
                        
                                    </div>
                                    <div class="col-md-4 col-sm-12 form-group mb-0 p-0">
                                        <ng-select
                                              #SelectSizeDefault
                                              [items]="flattenedCategories | documentTypeAllowedCategories: selectedDocumentType"
                                              [searchable]="false"
                                              formControlName="category_ids"
                                              bindLabel="category_name"
                                              bindValue="id"
                                              [multiple]="true"
                                              class="ng-select-modal-dropdown-panel bulk-upload-select"
                                              [placeholder]="t('Category label (Document right menu) - Category')"
                                              
                                            >

                                            
                                            <ng-template ng-option-tmp let-item="item" let-index="index">
                                                <span [ngClass]="{'potential-match': (file?.value.file | categoryFromPdf: pdfMatching | idIncluded: item.id) }">
                                                    {{ item.category_name }}
                                                </span>
                                            </ng-template>

                                        </ng-select>
                        
                                        <div *ngIf="file && file.get('category_ids').errors"
                                             class="invalid-feedback d-block">
                                            <div *ngIf="file.get('category_ids').errors.required">
                                                {{t('Field required (form validation) - Field name is required',{
                                                fieldName: t('Category label (Document right menu) - Category')})}}
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-md-4 col-sm-12 form-group mb-0 p-0">
                                        <app-contract-card-column [contractCardIds] = "file.get('contract_card_ids')?.value"
                                         (contractCardIdsChange)="file.get('contract_card_ids')?.setValue($event)" 
                                         [preselectedIds]="(file?.value.file | contractCardFromPdf: pdfMatching)"
                                         [items]="contractCards"
                                         (searchChanged)="onCCSearchChanged($event)"
                                         
                                         ></app-contract-card-column>
                                        <div *ngIf="file && file.get('contract_card_ids').errors"
                                             class="invalid-feedback d-block">
                                            <div *ngIf="file.get('contract_card_ids').errors.required">
                                                {{t('Field required (form validation) - Field name is required',{
                                                fieldName: t('Contract card column name (match contract card steps) - CONTRACT CARD')})}}
                                            </div>
                                        </div>
                                    </div>
                                </app-basic-file-upload>
                            } @empty () {
                                <div class="d-flex justify-content-center p-2">
                                    {{ t('Choose files notification (upload file modal) - Choose files to upload by dropping them on the left side or by using file browser') }}
                                </div>
                            }
                        </div>
                    </form>
                </div>
        </div>
    </div>
    </div>
</ng-container>
